import { useEffect } from 'react';

/**
 * #core
 * Hook that wraps the given function with a debounce effect.
 * The function will be called after the given wait time has passed.
 * If the function is called again before the wait time has passed,
 * the previous call will be cancelled and the timer will be restarted.
 * @param {function} fn - The function to debounce
 * @param {number} waitTime - The time in milliseconds to wait before calling the function
 * @param {array} deps - The dependencies for the useEffect hook
 */
export function useDebounceEffect(fn, waitTime, deps) {
  useEffect(() => {
    const t = setTimeout(() => {
      fn.apply(undefined, deps);
    }, waitTime);

    return () => {
      clearTimeout(t);
    };
  }, deps);
}
